import { Observable } from "rxjs";
import { CheckRideOwnershipTypeAllItems, CheckrideRequestSchoolCalendarQueryEntity, PilotExaminerEntity } from "../../../meta-data/app-meta-data.service";
import { CalendarDTO } from "../../calendar/models/calendar.model";
import { EventSearchRequestDTO } from "../../calendar/models/event-search-request.model";
import { CalendarControllerService } from "../../calendar/services/interfaces/calendar-controller-service.interface";
import { ScheduleBlockCalendarEvent } from "../../schedule-blocks/models/schedule-block-calendar-event.model";
import { CheckrideReferenceInfo } from "../models/checkride-reschedule-info.model";
import { CalendarRepositoryService } from "../../calendar/services/calendar-repository.service";
import { ExaminerRepositoryService } from "./examiner-repository.service";
import { ScheduleBlockService } from "../../schedule-blocks/services/schedule-block.service";
import { DwQueryMetaData } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { CalendarEventDTO } from "../../calendar/models/calendar-event.model";

@Injectable()
export class ExaminerCalendarControllerService implements CalendarControllerService {

    examiner: PilotExaminerEntity;

    constructor(protected calendarRepositoryService: CalendarRepositoryService,
        protected examinerRepositoryService: ExaminerRepositoryService,
        protected scheduleBlockService: ScheduleBlockService,
        //    protected router: Router,
        //    protected dwEventService: DwEventService,
        //    protected cdr: ChangeDetectorRef,
        //    protected dateTimeUtilService: DateTimeUtilService,
        //protected dwStyleManagerService: DwStyleManagerService
    ) { }

    getScheduleBlocks(eventSearchRequest: EventSearchRequestDTO, scheduleBlockId?: number): Observable<ScheduleBlockCalendarEvent[]> {
        return this.scheduleBlockService.getScheduleBlocks({ startDate: eventSearchRequest.StartDateTime, endDate: eventSearchRequest.EndDateTime, scheduleBlockId: scheduleBlockId, ownershipTypeId: this.getOwnershipTypeId() });
    }
    
    getCalendarEvents(request: EventSearchRequestDTO): Observable<CalendarEventDTO[]> {
        return this.calendarRepositoryService.getEvents(request);
    }

    getOwnershipTypeId(): number {
        return CheckRideOwnershipTypeAllItems.Examiner;
    }

    getCheckrides(eventSearchRequest: EventSearchRequestDTO, queryMetaData: DwQueryMetaData): Observable<CheckrideRequestSchoolCalendarQueryEntity[]> {
        return this.examinerRepositoryService.getCheckRidesRequests(queryMetaData, eventSearchRequest.StartDateTime, eventSearchRequest.EndDateTime);
    }

    useBlockBooking(): boolean {
        return !!this.examiner?.UseBlockBooking;
    }

    getCurrentCalendarRef(): Observable<any> {
         return this.examinerRepositoryService.getCurrentCalendarRef();
    }
    getCalendarMenu(): string {
        return 'calendar';
    }
    getCalendars(): Observable<CalendarDTO[]> {
       return this.calendarRepositoryService.getCalendars();
    }

    setCheckrideReferenceInfo(CheckRideRequestId: number, rescheduleInfo: CheckrideReferenceInfo) {
        this.examinerRepositoryService.setCheckrideReferenceInfo(CheckRideRequestId, rescheduleInfo);
    }

    loadSetupData(): Observable<any> {
         const examinerOb = this.examinerRepositoryService.getCurrentPilotExaminer()
            .pipe(tap(examiner => {
                this.examiner = examiner;
            }));

        return examinerOb;
    }

    allowCalendarIntegration(): boolean {
        return true;
    }

    canEditScheduleBlock(scheduleBlock: ScheduleBlockCalendarEvent): boolean {
        // Examiners can edit any of their blocks currently
        return true;
    }

    getEventDisplayOptions() : { showSchool: boolean, showExaminer: boolean } {
        return { showSchool: true, showExaminer: false };
    }

}